import React, {useEffect, useState} from "react";
import Form, {FormIsLoading} from "../../../components/fouladyar/form";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {convertDate} from "../../../shared/shared";
import {useLocation, useNavigate, useParams} from "react-router";
import {ErrorToaster, SuccessToaster} from "../../../shared/toaster";
import {useTranslation} from "react-i18next";
import {IoMdClose} from "react-icons/io";
import {Field} from "../../../components/fouladyar/field/field";


function GiftAccount({...props}) {

    const {t, i18n} = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [isLoading, setIsloading] = useState( false);


    //users
    const [users, setUsers] = useState( []);
    const [selectedUserId, setSelectedUserId] = useState( false);

    const [productCategories, setProductCategories] = useState([]);
    const [isCardsLoading, setIsCardsLoading] = useState(true);
    const [brokers, setBrokers] = useState([]);
    const [varieties, setVarieties] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedVarietyId, setSelectedVarietyId] = useState(null);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [brokerId, setBrokerId] = useState(null);
    const [isProductsLoading, setIsProductsLoading] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const [data, setData] = useState({
        "userId": "",
        "varietyId": "",
        "productId": "",
        "brokerId": "",
    });
    async function getUsers() {
        try {
            // setIsCardsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/list`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200 || !res.data.statusCode) {
                setUsers(res.data.data.users)
            }
            // setIsCardsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            // setIsProductsLoading(false)
        }

    }
    async function getVarieties() {
        try {
            // setIsCardsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/variety`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200 || !res.data.statusCode) {
                setVarieties(res.data.data.varieties)
                setSelectedVarietyId(res.data.data.varieties[0]?._id);
            }
            // setIsCardsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            // setIsProductsLoading(false)
        }

    }
    async function getProductCategories() {
        try {
            setIsCardsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories?section=product`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200 || !res.data.statusCode) {
                setProductCategories(res.data.data.categories)
                // setSelectedVarietyId(res.data.data.categories[1]?._id);

            }
            setIsCardsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsProductsLoading(false)
        }

    }
    async function getProductByVarietyId() {
        try {
            setIsProductsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/products/variety/${selectedVarietyId}`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })

            if (res.data.statusCode === 200 || !res.data.statusCode) {
                console.log('product',res.data.data.products)
                setProducts(res.data.data.products?.sort((a, b) => parseInt(a.slug) - parseInt(b.slug)))
                // setSelectedProductId(res.data.data.products[0])
            }

            setIsProductsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsProductsLoading(false)
        }
    }
    async function getBrokers(productId) {

        try {
            // setIsCardsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/brokers/in-stock/${productId}`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })

            console.log('brokers', res.data)
            if (res.data.statusCode === 200 || !res.data.statusCode) {
                setBrokers(res.data.data.brokers)
                // setBrokerId(res.data.data.brokers[0]._id)
            }
            // setIsCardsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            // setIsProductsLoading(false)
        }
    }

    useEffect(() => {
        getUsers();
        getVarieties();
        getProductCategories();
    }, []);

    useEffect(() => {
        if (selectedVarietyId)
            getProductByVarietyId(selectedVarietyId)
    }, [selectedVarietyId]);

    useEffect(() => {
        if (selectedProductId)
            getBrokers(selectedProductId)
    }, [selectedProductId]);



    async function submit() {

        try {
            setIsSubmitting(true)
            const selectedUser = users.find(user => user._id === selectedUserId);
            const body = {
                payableValue: 0,
                paymentMethod: 'crypto',
                paymentGatewayId: null,
                userId: selectedUserId,
                campaigns: [],
                addons: [],
                discount: null,
                cart: {
                    items:  [
                        { productId: selectedProductId,
                            varietyId: selectedVarietyId,
                            productType: "virtual",
                            quantity: 1
                        }
                    ]
                },
                extras: {
                    ...{
                        fullName: selectedUser?.fullName,
                        city: selectedUser?.city,
                        email: selectedUser?.email,
                        phone: selectedUser?.mobile,
                        privacyAndPolicy: true
                    },
                    broker: brokers.find(i=>i._id===brokerId)
                },
            }

            console.log('body', body)
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/orders/gift`, body,{
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200 || !res.data.statusCode) {
                const createdOrder = res.data.data.Order;

                console.log('order', createdOrder)
                //activateOrder
                const activation = await axios.post(`${process.env.REACT_APP_API_URL}/api/orders/complete/${createdOrder?._id}`, body,{
                    headers: {authorization: `Bearer ${auth.token}`}
                })

                if (activation.data.statusCode === 200) {
                    SuccessToaster({message: 'حساب هدیه با موفقیت فعال شد'})
                }
            }
            setIsSubmitting(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsSubmitting(false)
        }
    }



    function checkRequiredFields() {
        if (data.userId === '') {
            ErrorToaster({message: 'لطفا ایمیل کار برا انتخاب کنید'})
            return false
        }
        if (data.varietyId === '') {
            ErrorToaster({message: 'لطفا نوع پلن را انتخاب کنید'})
            return false
        }
        if (data.productId === '') {
            ErrorToaster({message: 'لطفا نوع محصول را انتخاب کنید'})
            return false
        }

        if (data.brokerId === '') {
            ErrorToaster({message: 'لطفا بروکر را انتخاب کنید'})
            return false
        }
        return true
    }

    return (

        <div>
            <div className="container-fluid select-plan-container">

                <h1>{"فعال سازی اکانت هدیه"}</h1>


                <div className="spacer"/>
                <p>
                    دقت کافی را در انتخاب نوع پلن، ایمیل کاربر و بالانس حساب و بروکر مورد نظر را بفرمایید، چرا که پس از انجام عملیات تغییر آن امکان پذیر نخواهد بود.
                </p>
                <div className="spacer"/>
            </div>
            <div className="kyc-form-row">
                <Field
                    label={"لطفا ایمیل کاربر مورد نظر خود را وارد کنید"}
                    id={"email"}
                    name={"email"}
                    type={'select'}
                    defaultValue={data.userId}
                    value={data.userId}
                    options={
                        users.map(item => {
                            return {label: item.email, value: item._id}
                        })
                    }
                    onChange={(e) => {
                        if(e) {
                            setData(prevState => {
                                return {
                                    ...prevState,
                                    userId: e
                                }
                            })
                            setSelectedUserId(e)
                        }
                    }}
                    onBlur={(e) => {
                    }}
                />
            </div>
            <div className="kyc-form-row">
                <Field
                    label={"لطفا نوع پلن خود را انتخاب کنید"}
                    id={"variety"}
                    name={"variety"}
                    type={'select'}
                    defaultValue={data.varietyId}
                    value={data.varietyId}
                    options={
                        varieties.map(item => {
                            return {label: item.name, value: item._id}
                        })
                    }
                    onChange={(e) => {
                        setData(prevState => {
                            return {
                                ...prevState,
                                varietyId: e
                            }
                        })
                        setSelectedVarietyId(e)

                    }}
                    onBlur={(e) => {
                    }}
                />
            </div>
            <div className="kyc-form-row">
                <Field
                    label={"نوع محصول خود را انتخاب کنید"}
                    id={"productId"}
                    name={"productId"}
                    type={'select'}
                    disabled={!data.varietyId}
                    defaultValue={data.productId}
                    value={data.productId}
                    options={
                        products.map(item => {
                            return {label: item.title, value: item._id}
                        })
                    }
                    onChange={(e) => {

                        if(e) {
                            console.log('product changes', e)
                            setData(prevState => {
                                return {
                                    ...prevState,
                                    productId: e
                                }
                            })
                            setSelectedProductId(e)
                        }

                    }}
                    onBlur={(e) => {
                    }}
                />
            </div>
            <div className="kyc-form-row">
                <Field
                    label={"نوع بروکر مورد نظر خود را انتخاب کنید"}
                    id={"brokerId"}
                    name={"brokerId"}
                    type={'select'}
                    disabled={!data.productId}
                    defaultValue={data.brokerId}
                    value={data.brokerId}
                    options={
                        brokers.map(item => {
                            return {label: item.name, value: item._id}
                        })
                    }
                    onChange={(e) => {
                        if(e) {
                            setData(prevState => {
                                return {
                                    ...prevState,
                                    brokerId: e
                                }
                            })
                            setBrokerId(e)
                        }

                    }}
                    onBlur={(e) => {
                    }}
                />
            </div>
            <div className={`form-submit-btn  ${!selectedProductId || !selectedUserId || !brokerId || !selectedVarietyId ? 'disabled' : ''}`}
                 onClick={async () => {
                     if (checkRequiredFields())
                         await submit()
                 }}>
                فعال سازی اکانت هدیه
            </div>
        </div>

    );
};

export default GiftAccount;
